import { render, staticRenderFns } from "./GoBroadToGoNarrow10.vue?vue&type=template&id=bf28124a&scoped=true&"
import script from "./GoBroadToGoNarrow10.vue?vue&type=script&lang=js&"
export * from "./GoBroadToGoNarrow10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf28124a",
  null
  
)

export default component.exports